import React, { FC, useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { Box } from 'components/box'
import { CreditDetail } from '../../credit-detail'
import { TermInput } from '../../term-input'
import { setInitialQuota, setTermState } from 'context/reducer/quota'
import { useDispatch } from 'react-redux'

export const DesktopTerms: FC<{doubt: any[]}> = ({
  doubt
}) => {

  const dispatch = useDispatch()
  const [open, setOpen] = useState(3)
  useEffect(() => {
    const currentTerm = doubt[open]
    if (open !== -1 && open < doubt.length) {
      dispatch(setInitialQuota(currentTerm?.quotaText))
      dispatch(setTermState(`${currentTerm?.term}`))
    }
  }, [open, doubt, dispatch])

  const onClick = (value: any, isOpen: boolean) => {
    setOpen(value)
    if (isOpen) {
      setOpen(-1)
    }
  }



  return (
    <>
      <Grid container justifyContent="flex-start" spacing={2}>
        {doubt.map((item, idx) => (
          <Grid item key={idx}>
            <Box
              id={`quota-${item.term}`}
              title={item.title}
              subtitle={item.subtitle}
              alignText="left"
              alignContent="flex-start"
              selected={open === idx}
              handleOnClick={() => onClick(idx, open === idx)}
            />
          </Grid>
        ))}
      </Grid>

      {open !== -1 && (
        <Grid container justifyContent='center'>
          <Grid item xs={7}>
            {doubt[open].isCalculated ? (
              <CreditDetail term={doubt[open]}></CreditDetail>
            ) : (
              <TermInput />
            )}
          </Grid>
        </Grid>
      )}
    </>
  )
}
